import create from 'zustand';
import { devtools } from 'zustand/middleware';
import api from '../lib/api';

const POLL_INTERVAL_MS = 30000;

const notificationStore = (set, get) => ({
  notifications: [],
  unreadCount: 0,
  loading: false,
  error: null,
  pollTimer: null,

  fetchNotifications: async () => {
    set({ loading: true, error: null });
    try {
      const res = await api.get('/api/notifications/');
      const data = Array.isArray(res.data) ? res.data : res.data.results || [];
      const unread = data.filter((n) => !n.is_read).length;
      set({ notifications: data, unreadCount: unread, loading: false });
    } catch (err) {
      if (err.response?.status !== 404) {
        console.error('Failed to fetch notifications:', err);
      }
      set({ loading: false, error: err.message });
    }
  },

  markAsRead: async (id) => {
    try {
      await api.patch(`/api/notifications/${id}/`, { is_read: true });
      set((state) => {
        const updated = state.notifications.map((n) =>
          n.id === id
            ? { ...n, is_read: true, read_at: new Date().toISOString() }
            : n
        );
        return {
          notifications: updated,
          unreadCount: updated.filter((n) => !n.is_read).length,
        };
      });
    } catch (err) {
      console.error('Failed to mark notification as read:', err);
    }
  },

  markAllAsRead: async () => {
    try {
      await api.post('/api/notifications/mark-all-read/');
      set((state) => ({
        notifications: state.notifications.map((n) => ({
          ...n,
          is_read: true,
          read_at: n.read_at || new Date().toISOString(),
        })),
        unreadCount: 0,
      }));
    } catch (err) {
      console.error('Failed to mark all notifications as read:', err);
    }
  },

  startPolling: () => {
    const { pollTimer, fetchNotifications } = get();
    if (pollTimer) return;
    fetchNotifications();
    const timer = setInterval(fetchNotifications, POLL_INTERVAL_MS);
    set({ pollTimer: timer });
  },

  stopPolling: () => {
    const { pollTimer } = get();
    if (pollTimer) {
      clearInterval(pollTimer);
      set({ pollTimer: null });
    }
  },
});

let useNotificationStore;
if (process.env.NODE_ENV !== 'production') {
  useNotificationStore = create(devtools(notificationStore));
} else {
  useNotificationStore = create(notificationStore);
}

export default useNotificationStore;
